export const computeChatPanelPosition = ({ anchorX, anchorY, viewportWidth, viewportHeight, panelWidth, panelHeight }) => {
	const preferredTop = (anchorY - 80) - panelHeight;
	const downTop = anchorY + 20;
	const fitsAbove = preferredTop >= 10;
	const flippedDown = !fitsAbove && downTop + panelHeight <= viewportHeight - 10;
	const top = fitsAbove
		? preferredTop
		: flippedDown
			? downTop
			: viewportHeight - 10 - panelHeight;
	const preferredLeft = (anchorX - 3) - panelWidth;
	const leftAligned = anchorX - 57;
	const left = preferredLeft >= 10
		? preferredLeft
		: leftAligned + panelWidth <= viewportWidth - 10
			? leftAligned
			: viewportWidth - 10 - panelWidth;
	return { top, left, flippedDown };
};

export const computeBubbleSide = ({ anchorX, viewportWidth }) =>
	anchorX - 30 >= viewportWidth / 2 ? 'left' : 'right';

export const computeBubbleShift = ({ bubbleLeft, bubbleRight, viewportWidth }) => {
	if (bubbleLeft < 10) {
		return 10 - bubbleLeft;
	}
	if (bubbleRight > viewportWidth - 10) {
		return viewportWidth - 10 - bubbleRight;
	}
	return 0;
};

// replica o teto do widget Blip (_resizeElements): maxHeight = outerHeight - 250
export const computeChatPanelHeight = ({ viewportOuterHeight }) =>
	Math.min(610, viewportOuterHeight - 250);
